export default __webpack_public_path__ + "static/media/shopping cart logo.bcaf93b8.png";